import fpApiUtil from "./fp-api-util";

// MasterController POST factoryplan/master/byproduct/byproducts(/save|/delete|/route-flo)
// - 목록: 공정(route) 1개당 [주품목 1행 + 부산물 N행]을 자식으로 갖는 트리(ByproductTreeDto)
// - 저장/삭제: 트리가 아니라 **부산물 행(ByProductDto)만** 보낸다(old preSaveData/preDeleteData와 동일)
// - route-flo: 선택한 공정 1개의 생산/소비/부산물 흐름(하단 다이어그램용)
const BASE = "factoryplan/master/byproduct/byproducts";

const getAll = (params) => fpApiUtil.postParams(BASE, params);
const upsert = (changes) => fpApiUtil.postChanges(`${BASE}/save`, changes);
const remove = (changes) => fpApiUtil.postChanges(`${BASE}/delete`, changes);
const getRouteFlo = (params) => fpApiUtil.postParams(`${BASE}/route-flo`, params);

const fpByproductService = { getAll, upsert, remove, getRouteFlo };
export default fpByproductService;
